import { motion } from "framer-motion";

export const PROJECTILE_FR = { none: "Atteinte directe", sling: "Lance-pierre", bow: "Arc et flèches", javelin: "Javelot" };
const VERB = { sling: "Vise avec le lance-pierre", bow: "Bande l'arc et vise", javelin: "Vise avec le javelot" };
export const aimInstruction = (kind, object) => `${VERB[kind]} ${object}, garde la visée puis relâche`;

/** Weapon held in Bao's hand, oriented along the aiming direction (angle in degrees, 0 = right). */
export const Weapon = ({ kind, at, angle }) => (
  <svg className="absolute overflow-visible" style={{ left: at[0], top: at[1] }} width="1" height="1">
    <g transform={`rotate(${angle}) scale(1.5)`} style={{ filter: "drop-shadow(0 4px 4px rgba(0,0,0,.3))" }}>
      {kind === "sling" && (
        <g>
          <path d="M-6 0 H22 M22 0 L40 -14 M22 0 L40 14" stroke="#7A4E2D" strokeWidth="7" strokeLinecap="round" fill="none" />
          <path d="M40 -14 Q30 0 40 14" stroke="#17A2A2" strokeWidth="3" fill="none" />
          <circle cx="32" cy="0" r="5" fill="#8A8F98" />
        </g>
      )}
      {kind === "bow" && (
        <g>
          <path d="M26 -40 Q52 0 26 40" stroke="#7A4E2D" strokeWidth="6" strokeLinecap="round" fill="none" />
          <path d="M26 -40 Q50 0 26 40" stroke="#E0B33A" strokeWidth="2" strokeDasharray="3 6" fill="none" />
          <path d="M26 -40 L4 0 L26 40" stroke="#F4ECDA" strokeWidth="1.6" fill="none" />
          <path d="M4 0 H64" stroke="#5A3A26" strokeWidth="3" /><path d="M64 0 l-9 -6 v12z" fill="#0A2540" />
          <path d="M4 0 l-6 -5 M4 0 l-6 5" stroke="#17A2A2" strokeWidth="3" />
        </g>
      )}
      {kind === "javelin" && (
        <g>
          <path d="M-40 0 H70" stroke="#7A4E2D" strokeWidth="5" strokeLinecap="round" />
          <path d="M0 0 H14" stroke="#17A2A2" strokeWidth="8" strokeLinecap="round" />
          <path d="M70 -6 L88 0 L70 6 Z" fill="#CBD5E1" stroke="#475569" strokeWidth="1.2" />
        </g>
      )}
    </g>
  </svg>
);

const Shape = ({ kind }) => {
  if (kind === "sling") return <circle cx="0" cy="0" r="7" fill="#8A8F98" stroke="#475569" strokeWidth="1.5" />;
  if (kind === "bow") return <g><path d="M-26 0 H20" stroke="#5A3A26" strokeWidth="3" /><path d="M24 0 l-10 -6 v12z" fill="#0A2540" /><path d="M-26 0 l-7 -6 M-26 0 l-7 6" stroke="#17A2A2" strokeWidth="3" /></g>;
  return <g><path d="M-50 0 H34" stroke="#7A4E2D" strokeWidth="5" strokeLinecap="round" /><path d="M34 -6 L52 0 L34 6Z" fill="#CBD5E1" stroke="#475569" /></g>;
};

/** Projectile flying on a slight arc from the hand to the release point. */
export const Projectile = ({ kind, from, to, duration = 0.45 }) => {
  const mid = [(from[0] + to[0]) / 2, Math.min(from[1], to[1]) - Math.abs(to[0] - from[0]) * 0.15 - 30];
  const angle = (Math.atan2(to[1] - from[1], to[0] - from[0]) * 180) / Math.PI;
  return (
    <motion.svg data-testid="projectile" className="pointer-events-none absolute z-20 overflow-visible" width="1" height="1"
      initial={{ x: from[0], y: from[1], opacity: 1 }} animate={{ x: [from[0], mid[0], to[0]], y: [from[1], mid[1], to[1]], opacity: [1, 1, 0.9] }}
      transition={{ duration, ease: "easeOut" }} style={{ left: 0, top: 0 }}>
      <g transform={`rotate(${kind === "sling" ? 0 : angle})`}><Shape kind={kind} /></g>
    </motion.svg>
  );
};

export const Reticle = ({ at, charge }) => (
  <svg className="pointer-events-none absolute z-20 overflow-visible" style={{ left: at[0], top: at[1] }} width="1" height="1" data-testid="aim-reticle">
    <circle r="22" fill="none" stroke="#fff" strokeWidth="2.5" strokeDasharray="5 5" />
    <circle r="22" fill="none" stroke="#E0B33A" strokeWidth="4" strokeDasharray={`${charge * 138} 138`} transform="rotate(-90)" strokeLinecap="round" />
    <path d="M-30 0 h12 M18 0 h12 M0 -30 v12 M0 18 v12" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
    <circle r="3" fill="#E0B33A" />
  </svg>
);
